import { useAtomValue } from "jotai";
import { activeVendorAtom } from "./vendor";
import { ScheduleDaysmart } from "./daysmart/Schedule";
import { ScheduleRecus } from "./recus/Schedule";
import { QuickBookRecus } from "./recus/QuickBook";

export function Schedule() {
  const vendor = useAtomValue(activeVendorAtom);
  if (vendor === "recus") {
    return (
      <div className="flex flex-col gap-4 w-full">
        <QuickBookRecus />
        <ScheduleRecus />
      </div>
    );
  }
  return <ScheduleDaysmart />;
}
